/**
 * View-as (Clerk impersonation) API client. Spec §7/§8.
 *
 * start -> backend mints a Clerk actor token and returns a one-time ticket the
 * caller redeems via signIn.create({strategy:'ticket'}). View-as is READ-ONLY
 * (enforced server-side); stop records the exit for audit.
 */
import { api } from '../utils/api';

export interface ViewAsStartResponse {
  ticket: string;
  actor_token_id?: string;
  target_user_id: string;
  read_only: boolean;
  expires_in_seconds: number;
}

export const startViewAs = (targetUserId: string) =>
  api.post<ViewAsStartResponse>('/api/v1/admin/view-as/start', { target_user_id: targetUserId });

export const logViewAsStop = () =>
  api.post('/api/v1/admin/view-as/stop', {}).catch(() => {
    /* audit-only; never block the exit on a failed log */
  });
